import type { IChallenge } from "@bbj-types/challenge";
import type { ISocialOffer } from "@bbj-types/offer";
import type { ProposalType, SocialApplyStatus } from "@bbj-types/socialApply/enum";
import type { ISocialApply } from "@bbj-types/socialApply/index.js";
import type { Override } from "@bbj-types/utils";
import { useCallback } from "react";
import type { IGetActionsData } from "../action";
import { axios } from "./axios";
import type { TCommunicationData } from "./types";

export type ISocialApplyBody = Omit<ISocialApply, "_id" | "createdAt" | "updatedAt" | "transitions" | "socialOffer"> & {
  socialOffer: Override<ISocialOffer, { perimeter?: string[] }>;
  challenges: IChallenge["_id"][];
  status: SocialApplyStatus;
  proposal: {
    type: ProposalType;
    communicationData?: TCommunicationData;
  };
};

export interface ISocialApplyCreateResponse {
  socialApply: ISocialApply[];
  action: IGetActionsData;
}

export const usePostSocialApply = () => {
  const [state, execute, cancel] = axios<ISocialApplyCreateResponse, ISocialApplyBody, unknown>(
    {
      url: "/apply/social",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: ISocialApplyBody) => {
      return execute({
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
